import { useAuth } from '../contexts/AuthContext';

export const useAuthState = () => {
  const { user, loading } = useAuth();

  return { 
    user, 
    loading 
  };
};